<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <h5 class="offcanvas-title col text-center" id="offcanvas-basic-title">{{ 'Busca Avançada' | translate }}</h5>
        <div class="cursor-pointer" (click)="offcanvas.dismiss('Cross click')"><i class="ti ti-x"></i></div>
    </div>

    <div class="offcanvas-fixed-footer">
        <div class="offcanvas-body-scrollable">
            <form class="form-filter-container" (submit)="$event.preventDefault()">
                <ng-content></ng-content>
            </form>
        </div>

        <div class="offcanvas-footer">
            <div class="d-flex gap-2">
                @if (showClearButton()) {
                    <button
                            type="button"
                            class="btn btn-outline-secondary flex-fill"
                            (click)="onClearClick()">
                        {{ clearButtonLabelKey() | translate }}
                    </button>
                }

                <button
                        type="button"
                        class="btn btn-dark flex-fill"
                        (click)="onApplyClick()">
                    {{ applyButtonLabelKey() | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<button [class]="buttonClass()" type="button" (click)="open(content)" [disabled]="disabled()">
    <i class="ti ti-adjustments-horizontal"></i> {{ buttonLabelKey() | translate }}
    @if (hasActiveFilters()) {
        <span class="badge bg-dark badge-sm">{{ activeFiltersCount() }}</span>
    }
</button>
